import React from 'react';
import styled, { css } from 'styled-components';

import type { ICardHeading } from './types';

export const CardHeading = (props: ICardHeading) => {
  const { text, url, isMobile, isBlack = false, hasMarginTop = false } = props;

  const href = `${url}?ref_content=main_page`;

  return (
    <StyledCardHeadingLink
      href={href}
      $isMobile={isMobile}
      $isBlack={isBlack}
      $hasMarginTop={hasMarginTop}
    >
      {text}
    </StyledCardHeadingLink>
  );
};

export const cardHeadingTextStyles = css<{
  $isMobile: boolean;
  $isBlack: boolean;
  $hasMarginTop: boolean;
}>`
  margin-top: ${({ $isMobile, $hasMarginTop }) =>
    ($hasMarginTop && ($isMobile ? 88 : 130)) || 0}px;
  margin-bottom: ${({ $isMobile }) => ($isMobile ? 14 : 6)}px;

  color: ${({ $isBlack }) => ($isBlack ? '#17181a' : '#fff')};

  font-size: 18px;
  line-height: 22px;
  font-weight: 700;
  margin-left: 4px;
`;

const StyledCardHeadingLink = styled.a<{
  $isMobile: boolean;
  $isBlack: boolean;
  $hasMarginTop: boolean;
}>`
  display: block;
  text-decoration: none;

  ${cardHeadingTextStyles}
`;
